import type { WidgetDefinition } from '@/types/widget';
import { helloWorldWidget } from './hello-world';
import { iframeWidget } from './iframe';
import { boardSummaryWidget } from './board-summary';
import { recentAgentActivityWidget } from './recent-agent-activity';
import { providerStatusWidget } from './provider-status';
import { costMeterWidget } from './cost-meter';
import { sourceHealthWidget } from './source-health';
import { codexRecentIngestsWidget } from './codex-recent-ingests';
import { quickSearchWidget } from './quick-search';
import { alertsWidget } from './alerts';
import { tenantClusterMapWidget } from './tenant-cluster-map';
import { crossTenantCostWidget } from './cross-tenant-cost';
import { systemHealthWidget } from './system-health';
import { subscriptionsOverviewWidget } from './subscriptions-overview';
import { pendingDecisionsWidget } from './pending-decisions';
import { agentBoardSummaryWidget } from './agent-board-summary';
import { ownerApprovalQueueWidget } from './owner-approval-queue';
import { agentRunInspectorWidget } from './agent-run-inspector';
import { agentLifecycleControlsWidget } from './agent-lifecycle-controls';
import { bondDelegationManagerWidget } from './bond-delegation-manager';
import { eligibleTaskDispatcherWidget } from './eligible-task-dispatcher';
import { researchStage1SummaryWidget } from './research-stage1-summary';

// Static registry. v1 ships built-in widgets only. Marketplace widgets (Bazaar)
// are v2 — they'll register dynamically into the same map. Contract is stable.

const REGISTRY: WidgetDefinition[] = [
  // ── Universal ──
  helloWorldWidget,
  iframeWidget,
  quickSearchWidget,
  alertsWidget,
  researchStage1SummaryWidget,

  // ── Tenant defaults ──
  boardSummaryWidget,
  recentAgentActivityWidget,
  providerStatusWidget,
  costMeterWidget,
  sourceHealthWidget,
  codexRecentIngestsWidget,

  // ── Director-only ──
  tenantClusterMapWidget,
  crossTenantCostWidget,
  systemHealthWidget,
  subscriptionsOverviewWidget,
  pendingDecisionsWidget,

  // ── Agent board (Lane 3) ──
  agentBoardSummaryWidget,
  ownerApprovalQueueWidget,
  agentRunInspectorWidget,
  agentLifecycleControlsWidget,
  bondDelegationManagerWidget,
  eligibleTaskDispatcherWidget,
];

export function allWidgets(): WidgetDefinition[] {
  return REGISTRY;
}

export function getWidget(id: string): WidgetDefinition | undefined {
  return REGISTRY.find((w) => w.id === id);
}

export function widgetsForScope(isDirector: boolean): WidgetDefinition[] {
  return REGISTRY.filter((w) => {
    if (w.scope === 'both') return true;
    if (w.scope === 'director') return isDirector;
    return !isDirector || w.scope === 'tenant';
  });
}
